'use client'

import { atomWithMutation, atomWithQuery, queryClientAtom } from 'jotai-tanstack-query'
import { sdk } from '@/payload'
import type { Subscriber } from '@/payload-types'

export const currentSubscriberAtom = atomWithQuery<Subscriber | null>(() => ({
	queryKey: ['subscribers', 'me'],
	queryFn: async () => {
		const res = await sdk.me({
			collection: 'subscribers',
		})
		return res.user ?? null
	},
	staleTime: 1000 * 60 * 5,
}))

export const logoutSubscriberAtom = atomWithMutation((get) => ({
	mutationKey: ['subscribers', 'logout'],
	mutationFn: async () => {
		const res = await sdk.request({
			method: 'POST',
			path: '/subscribers/logout',
		})

		return res
	},
	onSuccess: () => {
		// Immediately drop the current subscriber so UI updates instantly
		const queryClient = get(queryClientAtom)
		queryClient.setQueryData(['subscribers', 'me'], null)
	},
}))
